import React, { Component } from 'react';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from 'primereact/button';
import { Link } from 'react-router-dom';
import { StudentPortalMain } from './studentPortal/StudentPortalMain';
import { EM_USER_POINT } from '../../utils/PointWiseRouteConsts';
import { ErrorMessageView } from '../common/ErrorMessageView';
import { EmUserPointService } from '../../service/emUserPoint/EmUserPointService';
import NetiContentLoader from '../common/NetiContentLoader';
let userID;
export class GoToPortal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userList: [],
            dataTableIsLoading: false,
            topProgressBar: false,
            errorMsgVisible: false,
            errorMsgBody: '',
        };
        this.emUserPointService = new EmUserPointService();
        this.portalBody = this.portalBody.bind(this);
        this.NetiContentLoader = new NetiContentLoader();
    }

    componentWillMount() {
        this.setState({ dataTableIsLoading: true, topProgressBar: true, errorMsgVisible: false });
        this.emUserPointService.fetchMappedPortalList()
            .then((res) => {
                if (res.status == 302) {
                    return res.json().then((body) => {
                        console.log('Log: GoToPortal -> componentWillMount -> body', body)
                        this.setState({ userList: body })
                        this.setState({ dataTableIsLoading: false, topProgressBar: false, errorMsgVisible: false })
                    })
                } else {
                    this.emUserPointService.Auth.handleErrorStatus(res)
                        .then((responseBody) => {
                            this.setState({ topProgressBar: false, dataTableIsLoading: false, errorMsgVisible: true, errorMsgBody: responseBody })
                        });
                }
            }).catch((error) => {
                this.setState({ dataTableIsLoading: false, topProgressBar: false, errorMsgVisible: true, errorMsgBody: 'Unable to load data table. Please check connection' });
            });

    }

    portalBody = (rowData) => {

        if (rowData.mappingType === "Student") {

            return <div className='text-center'>
                <Link to={{ pathname: EM_USER_POINT.STUDENT_PORTAL, userStudentDetails: rowData }}><Button className="btn-lg bg-blue" label="Student" tooltip="Click for Details" /></Link>
            </div>

        } else if (rowData.mappingType === "HR") {

            return <div className='text-center'>
                <Link to={{ pathname: EM_USER_POINT.TEACHER_PORTAL, userHRDetails: rowData }}> <Button className="btn-lg bg-green" label="Employee" tooltip="Click for Details" /> </Link>
            </div>

        } else if (rowData.mappingType === "Guardian") {

            return <div className='text-center'>
                <Link to={{ pathname: EM_USER_POINT.STUDENT_PORTAL, userStudentDetails: rowData }}>  <Button className="btn-lg bg-parple" label="Guardian" tooltip="Click for Details" /> </Link>
            </div>

        }
    }

    useridTemplate = (rowData) => {
        return (
            <div>
                {rowData["mappingType"] == "Student" ? (rowData["userID"] = rowData["idForStudent"]) : ''}
                {rowData["mappingType"] == "Guardian" ? (rowData["userID"] = rowData["idForGuardian"]) : ''}
                {rowData["mappingType"] == "HR" ? (rowData["userID"] = rowData["idForHr"]) : ''}
            </div>
        )
    }

    render() {
        let { topProgressBar, errorMsgVisible, errorMsgBody } = this.state;
        const { userList } = this.state;

        let totalStudentUser;
        let totalHrUser;
        let totalGurdianUser;

        if (userList) {

            totalStudentUser = userList.filter(allUsersType => allUsersType.mappingType === 'Student');
            totalHrUser = userList.filter(allUsersType => allUsersType.mappingType === 'HR');
            totalGurdianUser = userList.filter(allUsersType => allUsersType.mappingType === 'Guardian');

        }

        let header = <div className="header-title">
                            <div className="header-title-left">
                                User List
                            </div>
                            <div className="header-title-right">
                                <a>
                                    Total Found: {userList.length}
                                </a>
                            </div>
                        </div>;
        return (
            <div className="p-fluid main-section netiWorld-DashBoard-wrapper">
                <div className="m-0">
                    <div className="p-fluid">
                        {topProgressBar ?
                            <ErrorMessageView
                                topProgressBar={topProgressBar}
                            />
                            : null
                        }
                        {errorMsgVisible ?
                            <ErrorMessageView
                                errorMsgVisible={errorMsgVisible}
                                errorMsgBody={errorMsgBody}
                            />
                            : null
                        }

                        <div className="layout-dashboard">
                            <div className="p-grid">
                                <div className="p-col-12 p-md-6 p-sm-6 p-lg-4 notify-myPoint-custom-div-size">
                                    <div className="notify-box-wrapper gradient-color-dark-blue">
                                        <div className="notify-box-wrapper-bg-image boxHeight-245">
                                            <div className="notify-box clearfix">
                                                <div className="notify-title-position-l-b">
                                                    <div className="notify-box-title">
                                                        <div className="notify-box-icon userGroup-icon"></div>
                                                        <h1 className="font-16 color-white">Total Student</h1>
                                                        <hr />
                                                        <div className="notify-currency">
                                                            <p className="font-20 color-white arrow-sign">{totalStudentUser.length}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-6 p-sm-6 p-lg-4 notify-myPoint-custom-div-size">
                                    <div className="notify-box-wrapper gradient-color-light-purple">
                                        <div className="notify-box-wrapper-bg-image boxHeight-245">
                                            <div className="notify-box clearfix">
                                                <div className="notify-title-position-l-b">
                                                    <div className="notify-box-title">
                                                        <div className="notify-box-icon gurdiansGroup-icon"></div>
                                                        <h1 className="font-16 color-white">Total Guardian</h1>
                                                        <hr />
                                                        <div className="notify-currency">
                                                            <p className="font-20 color-white arrow-sign">{totalGurdianUser.length}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-6 p-sm-6 p-lg-4 notify-myPoint-custom-div-size">
                                    <div className="notify-box-wrapper gradient-color-light-cyan">
                                        <div className="notify-box-wrapper-bg-image boxHeight-245">
                                            <div className="notify-box clearfix">
                                                <div className="notify-title-position-l-b">
                                                    <div className="notify-box-title">
                                                        <div className="notify-box-icon teacherGroup-icon"></div>
                                                        <h1 className="font-16 color-white">Total Employee</h1>
                                                        <hr />
                                                        <div className="notify-currency">
                                                            <p className="font-20 color-white arrow-sign">{totalHrUser.length}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br />
                        <div className="nw-data-table m-0">
                            {this.state.dataTableIsLoading ?
                                this.NetiContentLoader.MyPointTableLoader()
                                :
                                <DataTable
                                    value={this.state.userList}
                                    header={header}
                                    responsive={true}
                                    paginator={true}
                                    rows={5}
                                    rowsPerPageOptions={[10, 20, 50]}
                                >
                                    <Column field="mappingType" header="User Type" sortable={true} filter={true} />
                                    <Column field="userID" header="User ID" body={this.useridTemplate} sortable={true} filter={true} />
                                    {/* <Column field="emDetailsInfoDTO.assignedUserBasicInfoDTO.basicMobile" header="Mobile No." sortable={true} filter={true} /> */}
                                    <Column field="emDetailsInfoDTO.instituteId" header="Institute ID" sortable={true} filter={true} />
                                    <Column field="emDetailsInfoDTO.instituteName" header="Institute Name" sortable={true} filter={true} />
                                    <Column header="Portal" body={this.portalBody} />
                                </DataTable>
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}